import BMRecommendationRule from './BMRecommendationRule';
import { getMeasureScoreBySkillName } from '../utils/measureScoreBySkillName';
import { getMeasureScores } from '../utils/studentsListHelpers';

class ScoreRecommendationRule extends BMRecommendationRule {
    getIsRuleMet(studentResults) {
        const { skill, measure, score } = this.rule;
        const scoreName = getMeasureScoreBySkillName(skill, measure);
        const measureScores = getMeasureScores(studentResults, measure, scoreName);
        return measureScores?.rawScore === score;
    }
}

export default ScoreRecommendationRule;
